import axios from 'axios';
// import { useSelector } from 'react-redux';
import {
  SET_LOADING,
  LOGOUT,
  SET_USER,
  USER_REGISTER,
  OTP_VERIFICATION,
  ADD_SPARE_PARTS_DATA,
  ADD_CAR_DELEAR_DATA,
  // ADD_GARAGE_DATA,
  // ADD_CAR_RENT_DATA,
  // ADD_CAR_SALE_DATA,
  // UPDATE_CAR_RENT_DATA,
  // ADD_BANNER_DATA,
  // ADD_TAXI_DATA,
  ADD_MEDIA_DATA,
  GET_CAR_AGENT_LISTING,
  UPDATE_GARAGE_DATA,
  UPDATE_SPARE_PART_DATA,
  UPDATE_CAR_DEALER_DATA,
  UPDATE_TAXI_DATA,
  GET_GARAGE_FILTER_DATA,
  FORGOT_PASSWORD,
  UPDATE_PASSWORD,
  GET_GARAGE_CATEGORY,
  GET_GARAGE_CARBRAND,
  GET_SPARE_PART_CATEGORY,
  GET_CAR_DEALER_LISTING,
  GET_SPARE_PART_LISTING,
  GET_CAR_DEALER_CAR_LISTING,
  GET_CAR_WAHS_CATEGORY,
  GET_CAR_WASH_LISTING,
  GET_CAR_INSURANCE_CATEGORY,
  GET_CAR_INSURANCE_LISTING,
  GET_TAXI_OWNER_ALL_DATA,
  GET_CATEGORY,
  GET_DRIVING_SCHOOL_LISTING,
  GET_CAR_PROTECTION_LISTING,
  GET_AIR_CONDITIONING_LISTING,
  GET_QUICKSERVICES_LISTING,
  GET_cAR_RENT_LISTING,
  GET_cAR_RENT_CAR_LISTING,
  GET_MY_BUSINESS,
  GET_SPARE_PARTS,
  GET_TOWING_OWNER_ALL_DATA,
  GET_ALL_PLANS,
  GET_CAR_SALE_DATA,
  GET_CAR_MODEL_YEAR,
  GET_CAR_CYLINDER,
  GET_CAR_FUEL_TYPE,
  GET_CAR_SEATS,
  GET_CAR_DOORS,
  GET_CAR_COLORS,
  GET_CAR_SAFETY,
  GET_CAR_COMFORT,
  GET_CAR_MODELS,
  GET_SAVED_ITEMS_LIST,
  GET_RECENT_VIEWED_CARS_LIST,
  UPDATE_USER_PROFILE,
  GETTING_USER_PROFILE,
  GETTING_USER_CAR_DETAILS,
  USER_GARAGE_AZ_FILTER,
  USER_GARAGE_ZA_FILTER,
  FILTER_GARAGE_LIST_WITH_CATEGORY,
  USER_SPARE_PARTS_AZ_FILTER,
  USER_SPARE_PARTS_ZA_FILTER,
  FILTER_SPARE_PARTS_WITH_CATEGORY,
  GET_TAXI_OWNER_DATA,
  GET_SINGLE_CAR_TOWRING_DATA,
  GET_DRIVING_SCHHOL_WITH_FILTER,
  GETTING_USER_MY_POST,
  MAKE_NEW_PAYMENT,
  GET_GARAGE_SERVICES_DATA,
  GET_CURRENT_PLAN,
  GET_ALL_PACKAGES_HISTORY,
  GET_FILTERED_AIR_CONDITIONING_LISTING,
  GET_FILTERED_CAR_DEALER_LISTING,
} from './ActionType';
import Swal from 'sweetalert2';
/* [CF 2026-08-17] Every popup raised from here was hardcoded English -
   "Business created successfully", "Submit Successfully", the delete
   confirmations. These run outside React so there is no useTranslation hook;
   the i18n instance itself is imported and `i18n.t` resolves against whatever
   language is active at the moment the popup opens. */
import i18n from '../../i18n';
import { hideLoader, showLoader } from '../Reducers/LoaderReducer';
import { API_BASE_URL } from '../../config/api';

const getConfig = () => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
});

const getConfig2 = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
});

// Keep backward-compatible references (evaluated lazily via getters)
var config = null;
var config2 = null;

// SET LOADING
export const setLoading = (data) => (dispatch) => {
  dispatch({
    type: SET_LOADING,
    payload: data,
  });
};

// LOGIN
// const API = 'https://api.carsavenue.com/api';
// const API = "https://api.carsavenue.com/api";
const API = API_BASE_URL;
export const loginUser = (data) => (dispatch) => {
  try {
    // console.log('hd>>>>', data);
    axios

      .post(API + '/user/login', data)

      .then((res) => {
        dispatch({
          type: SET_USER,
          payload: res?.data,
        });

        Swal.fire({
          title: i18n.t('Login Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });

        console.log('resData', res.data);
        sessionStorage.setItem(
          'loged_In_auth',
          res.data.response.authToken ||
            (res.data.response.token
              ? `Bearer ${res.data.response.token}`
              : '')
        );
        sessionStorage.setItem('ucs-adminId', res.data.response.adminId);
        sessionStorage.setItem('ownerID', res.data.response.user?.userId);

        sessionStorage.setItem('loged_In', true);

        window.location.href = '#/';
        // Delay the reload so the '#/' hash commits first — an immediate reload
        // re-loads the previous (login) route and lands on a blank home. Mirrors
        // the working logout flow.
        setTimeout(() => window.location.reload(), 150);
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.response?.message
            ? err?.response?.data?.response?.message
            : i18n.t('Network Error Please Try again!!'),
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      });
  } catch (err) {
    // console.log('err ???', err);
    Swal.fire('Incorrect Credentials', '', 'error');
  }
};

// LOGOUT
export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT,
    payload: {},
  });
  // Redirect first, then clear session so the app doesn't briefly
  // render logged-in routes without auth and show the error page.
  window.location.href = '#/';
  setTimeout(() => {
    sessionStorage.clear();
    window.location.reload();
  }, 100);
};

// GOOGLE LOGIN
export const googleLogin = (data) => (dispatch) => {
  try {
    console.log('Google login data:', data);
    
    axios
      .post(API + '/user/login/google', data)
      .then((res) => {
        console.log('Google login response:', res.data);
        
        // Transform the response to match the expected format
        const transformedResponse = {
          response: {
            authToken: res.data.data.token,
            userId: res.data.data.user.userId,
            adminId: res.data.data.user.userId, // Using userId as adminId
            user: res.data.data.user
          }
        };

        dispatch({
          type: SET_USER,
          payload: transformedResponse,
        });

        Swal.fire({
          title: i18n.t('Login Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });

        sessionStorage.setItem(
          'loged_In_auth',
          res.data.data.authToken ||
            (res.data.data.token ? `Bearer ${res.data.data.token}` : '')
        );
        sessionStorage.setItem('ucs-adminId', res.data.data.user.userId);
        sessionStorage.setItem('ownerID', res.data.data.user.userId);
        sessionStorage.setItem('loged_In', true);

        window.location.href = '#/';
        // Delay the reload so the '#/' hash commits first — an immediate reload
        // re-loads the previous (login) route and lands on a blank home. Mirrors
        // the working logout flow.
        setTimeout(() => window.location.reload(), 150);
      })
      .catch((err) => {
        console.error('Google login error:', err);
        Swal.fire({
          title: err?.response?.data?.message
            ? err?.response?.data?.message
            : 'Google login failed. Please try again.',
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'error',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      });
  } catch (err) {
    console.error('Google login error:', err);
    Swal.fire('Google login failed', '', 'error');
  }
};

export const UpdatePassword = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/user/updatePassword', data)
    .then((res) => {
      dispatch({
        type: UPDATE_PASSWORD,
        payload: res,
      });
      // console.log(res);
      Swal.fire({
        title: res.data.response,
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      window.location.href = '#/login';
    })
    .catch((err) => {
      // console.log(err.response.data.response.message);
      Swal.fire({
        title: err.response.data.response.message,
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const ForgotPassword = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/user/forgotPassword', data)
    .then((res) => {
      dispatch({
        type: FORGOT_PASSWORD,
        payload: res,
      });
      // console.log('>>>>', res);
      Swal.fire({
        title: i18n.t('Register Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      window.location.href = '#/reset-password';
    })
    .catch((err) => {
      const errorMessage = err?.response?.data?.response?.message || err?.response?.data?.message || '';
      Swal.fire({
        title: errorMessage || 'User not found. Please check your username and try again.',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UserRegister = (user) => (dispatch) => {
  try {
    // console.log('hd>>>>', user);
    axios

      .post(API + '/user/register', user)

      .then((res) => {
        // console.log('heeee<<<<', res);
        dispatch({
          type: USER_REGISTER,
          payload: res.data.response,
        });

        if (res.data.response !== undefined) {
          dispatch({
            type: OTP_VERIFICATION,
            payload: res.data.response,
          });
          // console.log('Otp dispatch data', res.data.response);
          OtpVerification();
        }

        // console.log('response', res.data.response);

        // console.log('data is here<<<<', res);

        Swal.fire({
          title: i18n.t('Register Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });

        sessionStorage.setItem('OtpId', res.data.response.otpId);

        sessionStorage.setItem('otp', res.data.response.otp);
        window.location.href = '#/OtpVerification';
        // window.location.href = '#/register-as';
        // window.location.href = '#/login';
        // window.location.reload();
      })
      .catch((err) => {
        const errData = err?.response?.data;
        const errorMessage = errData?.response?.errors?.[0]?.message || errData?.response?.message || errData?.message || errData?.error || '';
        let title = 'Registration failed. Please try again.';
        if (errorMessage.toLowerCase().includes('taken') || errorMessage.toLowerCase().includes('exist') || errorMessage.toLowerCase().includes('duplicate') || errorMessage.toLowerCase().includes('already') || errorMessage.toLowerCase().includes('username')) {
          title = 'This username is already taken. Please choose a different one.';
        } else if (errorMessage) {
          title = errorMessage;
        }
        Swal.fire({
          title: title,
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          confirmButtonColor: '#3ab1f7',
          confirmButtonText: i18n.t('Ok'),
        });
      });
  } catch (err) {
    Swal.fire('Incorrect Credentials', '', 'error');
  }
};

export const OtpVerification = (otp) => (dispatch) => {
  try {
    axios

      .post(API + '/otp/verify', otp)

      .then((res) => {
        dispatch({
          type: OTP_VERIFICATION,
          payload: res,
        });

        Swal.fire({
          title: i18n.t('OTP Verified'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });

        sessionStorage.setItem(
          'loged_In_auth',
          res.data.response.authToken ||
            (res.data.response.token
              ? `Bearer ${res.data.response.token}`
              : '')
        );
        sessionStorage.setItem('ucs-adminId', res.data.response.isActive);
        sessionStorage.setItem('ad_name', res.data.response.otp);
        sessionStorage.setItem('loged_In', true);
        window.location.href = '#/register-as';

        window.location.reload();
      })
      .catch((err) => {
        // console.log(err);
        Swal.fire({
          title: i18n.t('Please Enter Correct OTP!!'),
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      });
  } catch (err) {
    // console.log('err ???', err);
    Swal.fire('Incorrect Credentials', '', 'error');
  }
};

export const ReOtpVerification = (otp) => (dispatch) => {
  try {
    axios

      .post(API + '/otp/verify', otp)

      .then((res) => {
        dispatch({
          type: OTP_VERIFICATION,
          payload: res.data,
        });

        Swal.fire({
          title: i18n.t('Register Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });

        sessionStorage.setItem('loged_In_auth', res.data.response.otpId);
        sessionStorage.setItem('ucs-adminId', res.data.response.isActive);
        sessionStorage.setItem('ad_name', res.data.response.otp);

        window.location.href = '#/OtpVerification';

        window.location.reload();
      })
      .catch((err) => {
        // console.log(err);
        Swal.fire({
          title: i18n.t('Registeration faild please try again!!!'),
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      });
  } catch (err) {
    // console.log('err ???', err);
    Swal.fire('Incorrect Credentials', '', 'error');
  }
};

export const getGarageDataWFilter = (garageOwnerId) => (dispatch) => {
  var object = { garageOwnerId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  // (garageOwnerId !== undefined ? '?' + query : '')
  axios
    .get(
      API +
        `/garageOwner/listing` +
        (garageOwnerId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_GARAGE_FILTER_DATA,
        payload: res.data.response.data,
      });
      // console.log('ress>>', res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getGarageDataWFilter error:', err);
      dispatch(setLoading(false));
    });
};

export const AddGarageListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();

  axios
    .post(API + '/garageOwner/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      // New business — send the owner to buy a subscription next (services /
      // banner / working-hours stay locked until a plan is active).
      Swal.fire({
        title: i18n.t('Business created successfully'),
        text: i18n.t('Next, choose a package to activate your listing.'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Buy a package'),
      }).then(() => {
        window.location.href = '#/manage-package';
      });
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateGarageListing = (data) => (dispatch) => {
  axios
    .put(API + '/garageOwner/listing', data, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_GARAGE_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getGarageServices = () => (dispatch) => {
  axios
    .get(
      API +
        `/garageOwner/service?garageOwnerId=${sessionStorage.getItem(
          'BusinessId'
        )}`,
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_GARAGE_SERVICES_DATA,
        payload: res,
      });
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const addGarageService = (data) => (dispatch) => {
  axios
    .post(API + `/garageOwner/service`, data, getConfig())
    .then((res) => {
      Swal.fire({
        title:
          res?.data !== undefined
            ? 'Service Added Successfully'
            : 'something went wrong',
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getGarageServices());
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const updateGarageService = (data) => (dispatch) => {
  axios
    .put(API + `/garageOwner/service`, data, getConfig())
    .then((res) => {
      Swal.fire({
        title:
          res?.data !== undefined
            ? 'Service Updated Successfully'
            : 'something went wrong',
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getGarageServices());
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const deleteService = (data) => (dispatch) => {
  console.log('data89', data);
  axios
    .delete(API + `/garageOwner/service?serviceId=${data}`, getConfig())
    .then((res) => {
      console.log('res89', res.data, res.response);
      Swal.fire({
        title: i18n.t('Service Deleted Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getGarageServices());
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddSparePartsListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/spareParts/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      dispatch({
        type: ADD_SPARE_PARTS_DATA,
        payload: res,
      });
      // console.log('this is the spare part data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .catch((err) => {
      console.log('sparePartPost', err?.response);
      Swal.fire({
        title: err?.response?.data?.response?.message,
        // 'Error! A problem has been occurred  while submitting your data please try again!!!'
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateSparePartListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);
  let banner = data.services;
  let workingHour = data.formData;

  axios
    .put(API + '/spareParts/listing', data, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_SPARE_PART_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      if (banner) {
        window.location.href = '#/sp-garages-banner';
      } else if (workingHour) {
        window.location.href = '#/sp-garages-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddSparePartsPart = (data) => (dispatch) => {
  axios
    .post(API + '/spareParts/part', { parts: data }, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_SPARE_PART_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getSparePartListing(sessionStorage.getItem('BusinessId')));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

// [CF] True in-place edit for a saved spare part. The backend PUT updates an
// existing owner-part row (targeted by sparePartsOwnerPartId) — it changes the
// part's brands + products but not its partId. On success refetch the list.
// Mirrors AddSparePartsPart's style.
export const UpdateSparePartPart = (data) => (dispatch) => {
  axios
    .put(API + '/spareParts/part', data, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_SPARE_PART_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Spare part updated successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getSparePartListing(sessionStorage.getItem('BusinessId')));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const DeleteSparePartParts = (data) => (dispatch) => {
  // Identify the part precisely: prefer the owner-part row id, and always send
  // the owning business id (sparePartsId) + partId so the backend can target
  // the exact part. (Previously partId was wrongly sent AS sparePartsId.)
  const businessId = sessionStorage.getItem('BusinessId');
  const params = new URLSearchParams();
  if (data?.sparePartsOwnerPartId)
    params.set('sparePartsOwnerPartId', data.sparePartsOwnerPartId);
  if (businessId) params.set('sparePartsId', businessId);
  if (data?.partId) params.set('partId', data.partId);
  axios
    .delete(API + '/spareParts/part?' + params.toString(), getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('SparePart Deleted Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // Refresh the list so the deleted part disappears immediately
      // (it previously stayed visible until a manual refresh).
      if (businessId) dispatch(getSparePartListing(businessId));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddCarDealerListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carDealer/listing', data, getConfig())
    .then((res) => {
      dispatch({
        type: ADD_CAR_DELEAR_DATA,
        payload: res,
      });
      // console.log('this is the car dealer data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // Refresh the business so the sidebar recognises it immediately (unlocks
      // sections / shows Buy Subscription) instead of needing a manual refresh.
      dispatch(getWhatIsMyBusiness());
      window.location.href = '#/manage-package';
    })
    .catch((err) => {
      // console.log('this is error', err.response.data.response);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        // 'Error! A problem has been occurred  while submitting your data please try again!!!'
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });

      // window.location.reload();
      // window.location.href = '#/sp-garages-services';
    });
};

export const UpdateCarDealerListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/carDealer/listing', data, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_CAR_DEALER_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // window.location.reload();
      // window.location.href = '#/sp-garages-packages';
      // console.log(res);
      // dispatch(setLoading(true));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        // 'Error! A problem has been occurred  while submitting your data please try again!!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getCarDealerCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/carDealer/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CATEGORY,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarAgentListing = (carAgentId) => (dispatch) => {
  dispatch(setLoading(true));
  // console.log('this is the data', data?.carDealerId);
  var object = { carAgentId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API + `/carAgent/listing` + (carAgentId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_AGENT_LISTING,
        payload: res.data.response.data,
      });
      // console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getCarAgentListing error:', err);
      dispatch(setLoading(false));
    });
};

export const UpdateCarAgentListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/carAgent/listing', data, getConfig())
    .then((res) => {
      // dispatch({
      // 	type: UPDATE_CAR_DEALER_DATA,
      // 	payload: res,
      // });
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // window.location.reload();
      // window.location.href = '#/sp-garages-packages';
      // console.log(res);
      // dispatch(setLoading(true));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        // 'Error! A problem has been occurred  while submitting your data please try again!!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getCarAgentCarListing = (data) => (dispatch) => {
  var businessId = sessionStorage.getItem('BusinessId');
  dispatch(setLoading(true));
  axios
    .get(API + `/carAgent/car?carAgentId=${businessId}`, getConfig())
    .then((res) => {
      dispatch({
        type: GET_CAR_DEALER_CAR_LISTING,
        payload: res.data.response.data,
      });
    });
};

export const AddCarInCarDealer = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios
    .post(API + '/carDealer/car', data, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Add successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarDealerCarListing());
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    })
    .catch((err) => {
      // Surface the real reason (e.g. the 403 "active subscription required")
      // instead of silently closing the form with no car added.
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          'Could not add the car. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UppdateCarInCarDealer = (data) => (dispatch) => {
  axios
    .put(API + '/carDealer/car', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Updated successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarDealerCarListing());
    })
    .catch((err) => {
      // [FB2-#6] Surface edit failures instead of failing silently (a car edit
      // that errored previously just closed the modal with no feedback).
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          'Could not update the car. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const DeleteCarInCarDealer = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios
    .delete(API + `/carDealer/car?carId=${data.carId}`, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarDealerCarListing());
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const AddCarAgentListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carAgent/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      // dispatch({
      // 	type: ADD_CAR_DELEAR_DATA,
      // 	payload: res,
      // });
      // console.log('this is the car dealer data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // window.location.href = '#/manage-package';
    })
    .catch((err) => {
      // console.log('this is error', err.response.data.response);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        // 'Error! A problem has been occurred  while submitting your data please try again!!!'
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });

      // window.location.reload();
      // window.location.href = '#/sp-garages-services';
    });
};

export const AddCarInCarAgent = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios
    .post(API + '/carAgent/car', data, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Add successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarAgentCarListing());
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          'Could not add the car. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UppdateCarInCarAgent = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios.put(API + '/carAgent/car', data, getConfig()).then((res) => {
    // console.log(res);
    Swal.fire({
      title: i18n.t('Updated successfully'),
      type: 'success',
      imageUrl: './assets/images/test.png',
      imageHeight: 100,
      confirmButtonColor: '#3ab1f7',
      cancelButtonColor: '#d33',
      confirmButtonText: i18n.t('Ok'),
    });
    dispatch(getCarAgentCarListing());
    // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
  });
  // .catch(err => console.log(err));
};

export const DeleteCarInCarAgent = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios
    .delete(API + `/carAgent/car?carId=${data.carId}`, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarAgentCarListing());
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const AddCarSaleListing = (data, onCreated) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carSale/listing', data, getConfig())
    .then((res) => {
      dispatch(setLoading(true));
      const newCarSaleId = res?.data?.response?.data?.carSaleId;
      // A car is only PUBLISHED after a package is chosen and paid for. Hand the
      // new carSaleId back to the page so it can open package selection, instead
      // of redirecting straight to the (still-unpublished) listing.
      if (typeof onCreated === 'function' && newCarSaleId) {
        dispatch(setLoading(false));
        // Guard: a UI error here (e.g. opening the package modal) must NOT fall
        // through to the .catch and wrongly show "a problem occurred" — the car
        // was already created successfully.
        try {
          onCreated(newCarSaleId);
        } catch (e) {
          console.error('post-create handler failed', e);
        }
        return;
      }
      // Fallback (no callback): keep the old behaviour.
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      }).then(() => {
        window.location.href = '#/user-cars-for-sale';
      });
    })
    .catch((err) => {
      // [CF] Build a SAFE message. The old ternary did
      // `data.response !== undefined ? data.response.message : fallback`, so when
      // the backend returned a `response` object WITHOUT a `.message` (or a
      // non-string one), the title became `undefined` → a BLANK popup. Always
      // fall back to a real string.
      const r = err?.response?.data;
      let msg =
        (typeof r?.response?.message === 'string' && r.response.message) ||
        (typeof r?.message === 'string' && r.message) ||
        '';
      // Backend validation errors come back as { response: { field: 'msg', ... } }
      // with no top-level message — surface those field messages instead of a
      // blank/generic error.
      if (!msg && r?.response && typeof r.response === 'object') {
        const vals = Object.values(r.response).filter(
          (v) => typeof v === 'string'
        );
        if (vals.length) msg = vals.join('\n');
      }
      if (!msg) {
        msg =
          'Error! A problem occurred while submitting your data. Please try again.';
      }
      Swal.fire({
        title: msg,
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

// Pay for (and thereby publish) a car-for-sale listing with a chosen package.
// FREE plans activate immediately; paid plans redirect to the Tap gateway.
export const PayForCarSale =
  ({ paymentPlan, carSaleId }) =>
  (dispatch) => {
    dispatch(setLoading(true));
    axios
      .post(
        API + '/payment/pay-car-sale',
        { paymentPlan, carSaleId },
        getConfig()
      )
      .then((res) => {
        dispatch(setLoading(false));
        if (res?.data?.success && res?.data?.data?.url) {
          // Paid plan — go to Tap in the SAME tab so it can redirect back.
          window.location.href = res.data.data.url;
          return;
        }
        if (res?.data?.success) {
          // FREE / activated immediately.
          Swal.fire({
            title: i18n.t('Your car is now published'),
            icon: 'success',
            confirmButtonColor: '#3ab1f7',
            confirmButtonText: i18n.t('Ok'),
          }).then(() => {
            window.location.href = '#/user-cars-for-sale';
          });
          return;
        }
        Swal.fire({
          title: res?.data?.message || 'Payment could not be started',
          icon: 'error',
          confirmButtonColor: '#3ab1f7',
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        Swal.fire({
          title:
            err?.response?.data?.message ||
            err?.response?.data?.response?.message ||
            i18n.t('Something went wrong. Please try again.'),
          icon: 'error',
          confirmButtonColor: '#3ab1f7',
        });
      });
  };

export const EditCarSaleListing = (data) => (dispatch) => {
  axios
    .put(API + '/carSale/listing', data, getConfig())
    .then((res) => {
      dispatch(setLoading(true));
      Swal.fire({
        title: i18n.t('Updated Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      }).then(() => {
        window.location.href = '#/settings-my-posts';
      });
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          'Error! A problem occurred while updating your data, please try again!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const fetCarSaleListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);
  dispatch(setLoading(true));

  axios.get(API + '/carSale/listing', data, getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_SALE_DATA,
      payload: res,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err));
};

export const AddCarRentListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carRent/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });

      window.location.reload();
    })
    .catch((err) => {
      // console.log(err);
      const r = err?.response?.data?.response;
      const rMsg =
        typeof r === 'string'
          ? r
          : r?.message ||
            (r && typeof r === 'object' ? Object.values(r)[0] : null);
      Swal.fire({
        title:
          rMsg ||
          err?.response?.data?.message ||
          'Error! A problem has been occurred  while submitting your data please try again!!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const CarRentAddCar = (data) => (dispatch) => {
  axios
    .post(API + '/carRent/car', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Car Added Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });

      dispatch(setLoading(true));
      dispatch(getcarRentCarListing());
    })
    .catch((err) => {
      // console.log(err);
      const r = err?.response?.data?.response;
      const rMsg =
        typeof r === 'string'
          ? r
          : r?.message ||
            (r && typeof r === 'object' ? Object.values(r)[0] : null);
      Swal.fire({
        title:
          rMsg ||
          err?.response?.data?.message ||
          'Error! A problem has been occurred  while submitting your data please try again!!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UppdateCarInCarRent = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios.put(API + '/carRent/car', data, getConfig()).then((res) => {
    // console.log(res);
    Swal.fire({
      title: i18n.t('Updated successfully'),
      type: 'success',
      imageUrl: './assets/images/test.png',
      imageHeight: 100,
      confirmButtonColor: '#3ab1f7',
      cancelButtonColor: '#d33',
      confirmButtonText: i18n.t('Ok'),
    });
    dispatch(getcarRentCarListing());
    // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
  });
  // .catch(err => console.log(err));
};

export const DeleteCarInCarRent = (data) => (dispatch) => {
  // console.log('this is add cgarage category', data);
  axios.delete(API + `/carRent/car?carId=${data.carId}`, getConfig()).then((res) => {
    // console.log(res);
    Swal.fire({
      title: i18n.t('Deleted successfully'),
      type: 'success',
      imageUrl: './assets/images/test.png',
      imageHeight: 100,
      confirmButtonColor: '#3ab1f7',
      cancelButtonColor: '#d33',
      confirmButtonText: i18n.t('Ok'),
    });
    dispatch(getcarRentCarListing());
    // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
  });
  // .catch(err => console.log(err));
};

export const UpdateCarRentListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/carRent/listing', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      window.location.reload();
      // window.location.href = '#/sp-garages-packages';
    })
    .catch((err) => {
      // [CF] Build a SAFE message. The old ternary did
      // `data.response !== undefined ? data.response.message : fallback`, so when
      // the backend returned a `response` object WITHOUT a `.message` (or a
      // non-string one), the title became `undefined` → a BLANK popup. Always
      // fall back to a real string.
      const r = err?.response?.data;
      let msg =
        (typeof r?.response?.message === 'string' && r.response.message) ||
        (typeof r?.message === 'string' && r.message) ||
        '';
      // Backend validation errors come back as { response: { field: 'msg', ... } }
      // with no top-level message — surface those field messages instead of a
      // blank/generic error.
      if (!msg && r?.response && typeof r.response === 'object') {
        const vals = Object.values(r.response).filter(
          (v) => typeof v === 'string'
        );
        if (vals.length) msg = vals.join('\n');
      }
      if (!msg) {
        msg =
          'Error! A problem occurred while submitting your data. Please try again.';
      }
      Swal.fire({
        title: msg,
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getTaxiListing = (data) => (dispatch) => {
  axios
    // axios.get takes (url, config) — merge params AND auth headers into one
    // config; a 3rd arg is ignored, which dropped the auth token.
    .get(API + '/taxiOwner/listing', { params: data, ...getConfig() })
    .then((res) => {
      console.log('res', res);

      dispatch({
        type: GET_TAXI_OWNER_DATA,
        payload: res?.data?.response?.data,
      });
      dispatch(setLoading(true));
    });
  // .catch(err => console.log(err));
};

export const AddTaxiListing = (data) => (dispatch) => {
  axios
    .post(API + '/taxiOwner/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      // Business created — guide the owner straight to buying a package, and
      // navigate away so a second Save click can't try to re-create it.
      Swal.fire({
        title: i18n.t('Business created successfully'),
        text: i18n.t('Next, choose a package to activate your listing.'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Buy a package'),
      }).then(() => {
        window.location.href = '#/manage-package';
      });
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateTaxiListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/taxiOwner/listing', data, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_TAXI_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Updated Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // window.location.href = '#/sp-garages-packages';
      // console.log(res);
      // dispatch(setLoading(true));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title: i18n.t('Error! A problem has been occurred  while submitting your data please try again!!!'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddMedia = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios media data', data);

  axios
    .post(API + '/media/new', data.formData, getConfig2())

    .then((res) => {
      dispatch({
        type: ADD_MEDIA_DATA,
        payload: res,
      });

      // `silent` callers (e.g. the logo upload) show the uploaded image inline
      // as their own confirmation, so they skip this success popup.
      if (!data.silent) {
        Swal.fire({
          title: i18n.t('Upload Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      }
      if (data.pathData === 'sp-garages-banner') {
        window.location.href = '#/sp-garages-working-hours';
      } else if (data.pathData === 'sp-spare-parts-banner') {
        window.location.href = '#/sp-spare-parts-working-hours';
      } else if (data.pathData === 'sp-car-dealers-working-hours') {
        window.location.href = '#/sp-car-dealers-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response !== undefined
            ? err?.response?.data?.response?.message
            : 'something went wrong Upload again!!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddBannerMedia = (data) => (dispatch) => {
  axios
    .post(API + '/media/new', data.formData, getConfig2())

    .then((res) => {
      dispatch({
        type: ADD_MEDIA_DATA,
        payload: res,
      });
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err.response !== undefined
            ? err.response.data.response.message
            : 'something went wrong or network Problem',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getGarageCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/garageOwner/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_GARAGE_CATEGORY,
      payload: res.data,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarBrand = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/brand/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_GARAGE_CARBRAND,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarModelYear = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/modelYear/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_MODEL_YEAR,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarCylinder = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/cyclinder/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_CYLINDER,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarFuelType = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/fuelType/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_FUEL_TYPE,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarSeat = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/seat/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_SEATS,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarDoor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/door/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_DOORS,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarColor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/color/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_COLORS,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarSafety = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/safety/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_SAFETY,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarComfort = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/comfort/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_COMFORT,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getSparePartCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/spareParts/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_SPARE_PART_CATEGORY,
      payload: res.data,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarDealerCarListing = (data) => (dispatch) => {
  var businessId = sessionStorage.getItem('BusinessId');
  dispatch(setLoading(true));
  axios
    .get(API + `/carDealer/car?businessId=${businessId}`, getConfig())
    .then((res) => {
      dispatch({
        type: GET_CAR_DEALER_CAR_LISTING,
        payload: res.data.response.data,
      });
    });
};

export const getSparePartListing = (sparePartsId) => (dispatch) => {
  dispatch(setLoading(true));

  var object = { sparePartsId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        '/spareParts/listing' +
        (sparePartsId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_SPARE_PART_LISTING,
        payload: res.data.response.data,
      });
      // console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getSparePartListing error:', err);
      dispatch(setLoading(false));
    });
};

export const getCarDealerListing = (carDealerId) => (dispatch) => {
  dispatch(setLoading(true));
  // console.log('this is the data', data?.carDealerId);
  var object = { carDealerId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        `/carDealer/listing` +
        (carDealerId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_DEALER_LISTING,
        payload: res.data.response.data,
      });
      // console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getCarDealerListing error:', err);
      dispatch(setLoading(false));
    });
};

// [CF 2026-08-02] Car Dealers filtered by the CARS a dealer stocks.
// Unlike Cars for Sale, the dealer listing returns BUSINESSES with no car data
// attached, so this cannot be done in the browser — the API does it: the
// service fetches the matching cars for the dealer ids it found and keeps only
// the dealers that have at least one. Supported params (checked against
// carDealer.service.js): carBrandId, carModel, modelYearId, interiorColorId,
// exteriorColorId, fromPrice/toPrice, fromKilometerDriven/toKilometerDriven,
// fromCarAge/toCarAge. Fuel type and cylinder are NOT supported there.
// [CF 2026-08-02] Rent a Car filtered by the cars a company rents out. Same
// shape as the dealer version — the listing rows are COMPANIES with no car
// detail, so the API answers "which companies have a car like this?".
// `carRent.service.js` gained these params the same day. Rental cars carry no
// odometer, and the daily rate lives on each car's packages, so there is no
// kilometre filter and the price range is matched against `starting_price`.
export const getCarRentListingFiltered = (filter) => (dispatch) => {
  dispatch(setLoading(true));
  const map = {
    carBrandId: filter?.brandId,
    carModel: filter?.carModel,
    // [CF 2026-08-09 #8] the same model under its Arabic name — most stock
    // stores the Arabic spelling, the dropdown's value is the English one.
    carModelAr: filter?.carModelAr,
    modelYearId: filter?.modelYearId,
    fuelTypeId: filter?.fuelTypeId,
    cyclinderId: filter?.cyclinderId,
    exteriorColorId: filter?.exteriorColorId,
    interiorColorId: filter?.interiorColorId,
    fromPrice: filter?.priceMin,
    toPrice: filter?.priceMax,
  };
  const query = Object.keys(map)
    .filter((k) => map[k] !== undefined && map[k] !== null && String(map[k]) !== '')
    .map((k) => k + '=' + encodeURIComponent(map[k]))
    .join('&');

  axios
    .get(API + '/carRent/listing' + (query ? '?' + query : ''), getConfig())
    .then((res) => {
      dispatch({ type: GET_cAR_RENT_LISTING, payload: res.data.response.data });
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getCarRentListingFiltered error:', err);
      dispatch(setLoading(false));
    });
};

export const getCarDealerListingFiltered = (filter) => (dispatch) => {
  dispatch(setLoading(true));
  const map = {
    carBrandId: filter?.brandId,
    carModel: filter?.carModel,
    // [CF 2026-08-09 #8] the same model under its Arabic name — most stock
    // stores the Arabic spelling, the dropdown's value is the English one.
    carModelAr: filter?.carModelAr,
    modelYearId: filter?.modelYearId,
    exteriorColorId: filter?.exteriorColorId,
    interiorColorId: filter?.interiorColorId,
    fromPrice: filter?.priceMin,
    toPrice: filter?.priceMax,
    fromKilometerDriven: filter?.kmMin,
    toKilometerDriven: filter?.kmMax,
  };
  const query = Object.keys(map)
    .filter((k) => map[k] !== undefined && map[k] !== null && String(map[k]) !== '')
    .map((k) => k + '=' + encodeURIComponent(map[k]))
    .join('&');

  axios
    .get(API + '/carDealer/listing' + (query ? '?' + query : ''), getConfig())
    .then((res) => {
      dispatch({
        type: GET_CAR_DEALER_LISTING,
        payload: res.data.response.data,
      });
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getCarDealerListingFiltered error:', err);
      dispatch(setLoading(false));
    });
};

export const getFilteredCarDealerListing = (categoryId) => (dispatch) => {
  dispatch(setLoading(true));
  // console.log('this is the data', data?.carDealerId);
  var object = { category: categoryId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        `/carDealer/listing` +
        (categoryId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_FILTERED_CAR_DEALER_LISTING,
        payload: res.data.response.data,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    });
  // .catch(err => console.log(err));
};

export const AddCarWashListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carWash/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      // console.log('this is the spare part data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.message,
        // 'Error! A problem has been occurred  while submitting your data please try again!!!'
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddCarTowingListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/towingOwner/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      // Business created — guide the owner straight to buying a package, and
      // navigate away so a second Save click can't try to re-create it.
      Swal.fire({
        title: i18n.t('Business created successfully'),
        text: i18n.t('Next, choose a package to activate your listing.'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Buy a package'),
      }).then(() => {
        window.location.href = '#/manage-package';
      });
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.message,
        // 'Error! A problem has been occurred  while submitting your data please try again!!!'
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateCarTowingListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/towingOwner/listing', data, getConfig())
    .then((res) => {
      dispatch({
        type: UPDATE_TAXI_DATA,
        payload: res,
      });
      Swal.fire({
        title: i18n.t('Updated Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // window.location.href = '#/sp-garages-packages';
      // console.log(res);
      // dispatch(setLoading(true));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title: i18n.t('Error! A problem has been occurred  while submitting your data please try again!!!'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateCarWashListing = (data, opts = {}) => (dispatch) => {
  let banner = data.services;
  let workingHour = data.formData;
  var id = sessionStorage.getItem('BusinessId');
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/carWash/listing', data, getConfig())
    .then((res) => {
      if (!opts.silent) {
        Swal.fire({
          title: i18n.t('Submit Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      }
      dispatch(getCarWashListing(id));
      if (banner) {
        window.location.href = '#/sp-garages-banner';
      } else if (workingHour) {
        window.location.href = '#/sp-garages-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const DeleteCarWashPackage = (data) => (dispatch) => {
  var id = sessionStorage.getItem('BusinessId');
  axios
    .delete(API + `/carWash/package?packageId=${data.packId}`, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarWashListing(id));
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const getCarWashCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/carWash/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_WAHS_CATEGORY,
      payload: res.data,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const getCarWashListing = (carWashId) => (dispatch) => {
  dispatch(showLoader());
  var object = { carWashId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API + '/carWash/listing' + (carWashId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_WASH_LISTING,
        payload: res.data.response,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => console.log(err))
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const getCarInsuranceCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/carInsurance/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CAR_INSURANCE_CATEGORY,
      payload: res.data,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const AddCarInsuranceListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carInsurance/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      // console.log('this is the spare part data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.message,
        // 'Error! A problem has been occurred  while submitting your data please try again!!!'
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const DeleteCarInsurancePackage = (data) => (dispatch) => {
  var id = sessionStorage.getItem('BusinessId');
  axios
    .delete(API + `/carInsurance/package?packageId=${data.packId}`, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarInsuranceListing(id));
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const UpdateCarInsuranceListing = (data, opts = {}) => (dispatch) => {
  let banner = data.services;
  let workingHour = data.formData;
  // console.log('this is inside axios cardealer', data);
  var id = sessionStorage.getItem('BusinessId');

  axios
    .put(API + '/carInsurance/listing', data, getConfig())
    .then((res) => {
      if (!opts.silent) {
        Swal.fire({
          title: i18n.t('Submit Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      }
      dispatch(getCarInsuranceListing(id));
      // if (banner) {
      // 	window.location.href = '#/sp-garages-banner';
      // } else if (workingHour) {
      // 	window.location.href = '#/sp-garages-working-hours';
      // }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getCarInsuranceListing = (carInsuranceId) => (dispatch) => {
  dispatch(showLoader());
  var object = { carInsuranceId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        '/carInsurance/listing' +
        (carInsuranceId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_INSURANCE_LISTING,
        payload: res.data?.response,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => console.log(err))
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const getTaxiOwnerAllListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios', data);
  dispatch(showLoader());
  axios
    .get(
      API + `/taxiOwner/listing`,

      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_TAXI_OWNER_ALL_DATA,
        payload: res.data?.response,
      });
      // console.log('ress>>', res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getTaxiOwnerAllListing error:', err);
      dispatch(setLoading(false));
    })
    .finally(() => dispatch(hideLoader()));
};

export const getCarTowingAllListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios', data);
  dispatch(showLoader());
  axios
    // axios.get takes (url, config) — pass params AND auth headers together,
    // not as a 3rd arg (which axios ignores, dropping the auth token).
    .get(API + `/towingOwner/listing`, { params: data, ...getConfig() })
    .then((res) => {
      dispatch({
        type: GET_TOWING_OWNER_ALL_DATA,
        payload: res.data?.response?.data,
      });
    })
    .catch((err) => console.log(err))
    .finally(() => {
      dispatch(hideLoader());
    });
};
export const getSingleCarTowing = (data) => (dispatch) => {
  dispatch(showLoader());
  axios
    .get(API + `/towingOwner/listing?towingOwnerId=${data}`, getConfig())
    .then((res) => {
      dispatch({
        type: GET_SINGLE_CAR_TOWRING_DATA,
        payload: res.data?.response?.data,
      });

      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getSingleCarTowing error:', err);
      dispatch(setLoading(false));
    })
    .finally(() => dispatch(hideLoader()));
};

export const getDrivingSchoolCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/drivingSchool/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CATEGORY,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};
export const getDrivingSchoolWithFilter = (data) => (dispatch) => {
  dispatch(showLoader());

  axios
    .get(API + `/drivingSchool/listing?gender=${data}`, getConfig())
    .then((res) => {
      dispatch({
        type: GET_DRIVING_SCHHOL_WITH_FILTER,
        payload: res?.data?.response,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(hideLoader()));
};

export const AddDrivingSchool = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);
  dispatch(showLoader());

  axios
    .post(API + '/drivingSchool/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      // console.log('this is the spare part data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const UpdateDrivingSchool = (data, opts = {}) => (dispatch) => {
  dispatch(showLoader());
  let banner = data.services;
  let workingHour = data.formData;
  // console.log('this is inside axios cardealer', data);
  var id = sessionStorage.getItem('BusinessId');

  axios
    .put(API + '/drivingSchool/listing', data, getConfig())
    .then((res) => {
      if (!opts.silent) {
        Swal.fire({
          title: i18n.t('Submit Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      }
      dispatch(getDrivingSchoolListing(id));
      if (banner) {
        window.location.href = '#/sp-garages-banner';
      } else if (workingHour) {
        window.location.href = '#/sp-garages-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const DeleteDrivingSchoolPackage = (data) => (dispatch) => {
  var id = sessionStorage.getItem('BusinessId');
  axios
    .delete(API + `/drivingSchool/package?packageId=${data.packId}`, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getDrivingSchoolListing(id));
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const getDrivingSchoolListing = (drivingSchoolId) => (dispatch) => {
  dispatch(showLoader());
  var object = { drivingSchoolId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        '/drivingSchool/listing' +
        (drivingSchoolId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_DRIVING_SCHOOL_LISTING,
        payload: res.data.response,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => {
      // console.log(err);
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const getCarProtectionCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/carProtection/category/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CATEGORY,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const AddCarProtection = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/carProtection/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Car Protection was the one category that did NOT
         move after a successful save — it showed "Submit Successfully" and left
         the owner sitting on the form they had just filled in, with no sign of
         what to do next. Every other category now sends them to buy a package,
         so this does too. */
      Swal.fire({
        title: i18n.t('Business created successfully'),
        text: i18n.t('Next, choose a package to activate your listing.'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Buy a package'),
      }).then(() => {
        window.location.href = '#/manage-package';
      });
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateCarProtection = (data, opts = {}) => (dispatch) => {
  let banner = data.services;
  let workingHour = data.formData;
  // console.log('this is inside axios cardealer', data);
  var id = sessionStorage.getItem('BusinessId');
  axios
    .put(API + '/carProtection/listing', data, getConfig())
    .then((res) => {
      if (!opts.silent) {
        Swal.fire({
          title: i18n.t('Submit Successfully'),
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: i18n.t('Ok'),
        });
      }
      dispatch(getCarProtectionListing(id));
      if (banner) {
        window.location.href = '#/sp-garages-banner';
      } else if (workingHour) {
        window.location.href = '#/sp-garages-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const DeleteCarProtectionPackage = (data) => (dispatch) => {
  var id = sessionStorage.getItem('BusinessId');
  axios
    .delete(API + `/carProtection/package?packageId=${data.packId}`, getConfig())
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getCarProtectionListing(id));
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const getCarProtectionListing = (carProtectionId) => (dispatch) => {
  dispatch(showLoader());
  var object = { carProtectionId };
  console.log('carProtectionId', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);
  console.log('this is the query,', query);
  axios
    .get(
      API +
        '/carProtection/listing' +
        (carProtectionId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_PROTECTION_LISTING,
        payload: res.data.response,
      });
      console.log('heeee<<<<', res.data.response);
      dispatch(hideLoader());
    })
    .catch((err) => {
      console.error('getCarProtectionListing error:', err);
      dispatch(hideLoader());
    });
};

export const getAirConditioningCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/service/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CATEGORY,
      payload: res?.data?.response,
    });
    // console.log(res);
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const AddAirConditioningListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios cardealer', data);

  axios
    .post(API + '/airConditioning/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      // console.log('this is the spare part data', res);
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      window.location.reload();
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const AddAirConditioningServices = (data) => (dispatch) => {
  axios
    .post(API + '/airConditioning/service', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getAirConditioningListing(sessionStorage.getItem('BusinessId')));
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateAirConditioningListing = (data) => (dispatch) => {
  let banner = data.services;
  let workingHour = data.formData;
  // console.log('this is inside axios cardealer', data);

  axios
    .put(API + '/airConditioning/listing', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      if (banner) {
        window.location.href = '#/sp-air-conditioning-banner';
      } else if (workingHour) {
        window.location.href = '#/sp-air-conditioning-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateAirConditioningService = (data) => (dispatch) => {
  axios
    .put(API + '/airConditioning/service', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Updated Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      window.location.reload();
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getAirConditioningListing = (airConditioningId) => (dispatch) => {
  dispatch(showLoader());
  var object = { airConditioningId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        '/airConditioning/listing' +
        (airConditioningId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_AIR_CONDITIONING_LISTING,
        payload: res.data.response,
      });
      console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(hideLoader()));
};

export const getFilteredAirConditioningListing = (categoryId) => (dispatch) => {
  dispatch(setLoading(true));
  var object = { category: categoryId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API +
        '/airConditioning/listing' +
        (categoryId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_FILTERED_AIR_CONDITIONING_LISTING,
        payload: res.data.response,
      });
      console.log(res);
      // dispatch(setLoading(false));
    });
  // .catch(err => console.log(err));
};

export const DeleteAirconditioningService = (data) => (dispatch) => {
  axios
    .delete(
      API +
        `/airConditioning/service?airConditioningServiceId=${data?.airConditioningServiceId}&businessId=${data?.businessId}`,
      getConfig()
    )
    .then((res) => {
      Swal.fire({
        title: i18n.t('Service Deleted Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // Refresh the list so the deleted service disappears immediately
      // (it previously stayed visible until a manual refresh).
      dispatch(
        getAirConditioningListing(
          data?.businessId || sessionStorage.getItem('BusinessId')
        )
      );
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getQuickServicesListing = (quickServiceOwnerId) => (dispatch) => {
  dispatch(setLoading(true));
  var object = { quickServiceOwnerId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  // (garageOwnerId !== undefined ? '?' + query : '')

  axios
    .get(
      API +
        '/quickServiceOwner/listing' +
        (quickServiceOwnerId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_QUICKSERVICES_LISTING,
        payload: res.data.response,
      });
      // console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error('getQuickServicesListing error:', err);
      dispatch(setLoading(false));
    });
};

export const getQuickServicesCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/admin/quickService/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_CATEGORY,
      payload: res?.data?.response,
    });
    // dispatch(setLoading(false));
  });
  // .catch(err => console.log(err));
};

export const AddQuickServicesListing = (data) => (dispatch) => {
  axios
    .post(API + '/quickServiceOwner/listing', data, getConfig())
    .then((res) => {
      // Refresh business so the manage sidebar unlocks without a manual refresh.
      dispatch(getWhatIsMyBusiness());
      /* [CF 2026-08-17 G4] Client: after the first Save the page just sat
         there. Post-save behaviour was inconsistent across the twelve
         categories — six redirected nowhere at all, three went to the
         package screen, and Car Dealers AND Car Agents both went to the
         car-dealers cars page (a copy-paste). Every category now lands on
         its OWN Manage Business hub, which is what the client asked for and
         is also where the newly-unlocked sections and the subscription card
         are shown. */
      window.location.href = '#/manage-package';
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      window.location.reload();
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};
export const AddServiceINQuickService = (data) => (dispatch) => {
  axios
    .post(API + '/quickServiceOwner/service', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getQuickServicesListing(sessionStorage.getItem('BusinessId')));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

// [CF] True in-place edit for a saved quick-service service. The backend PUT
// updates an existing service (targeted by businessQuickServiceId) instead of
// adding a new row. On success refetch the list. Mirrors
// AddServiceINQuickService's style.
export const UpdateQuickServiceService = (data) => (dispatch) => {
  axios
    .put(API + '/quickServiceOwner/service', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Service updated successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getQuickServicesListing(sessionStorage.getItem('BusinessId')));
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),

        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const UpdateQuickServicesListing = (data) => (dispatch) => {
  let banner = data.services;
  let workingHour = data.formData;

  axios
    .put(API + '/quickServiceOwner/listing', data, getConfig())
    .then((res) => {
      Swal.fire({
        title: i18n.t('Submit Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      if (banner) {
        window.location.href = '#/sp-quick-services-banner';
      } else if (workingHour) {
        window.location.href = '#/sp-quick-services-working-hours';
      }
    })
    .catch((err) => {
      // console.log(err);
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          i18n.t('Something went wrong. Please try again.'),
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const DeleteQuickServiceService = (data) => (dispatch) => {
  var id = sessionStorage.getItem('BusinessId');
  // [FB2-#7] Delete ONLY the one service. Previously this also sent
  // quickServiceOwnerId, which triggers the backend "delete every service for
  // this owner" branch (deleteListing) — so removing one service wiped ALL of
  // them. Send just businessQuickServiceId so exactly one row is deleted.
  axios
    .delete(
      API +
        `/quickServiceOwner/service?businessQuickServiceId=${data.businessQuickServiceId}`,
      getConfig()
    )
    .then((res) => {
      // console.log(res);
      Swal.fire({
        title: i18n.t('Deleted successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // Refresh the QUICK-SERVICE list (was wrongly refetching car-wash).
      dispatch(getQuickServicesListing(id));
      // window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    });
  // .catch(err => console.log(err));
};

export const getcarRentListing = (carRentId) => (dispatch) => {
  dispatch(showLoader());

  var object = { carRentId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  axios
    .get(
      API + '/carRent/listing' + (carRentId !== undefined ? '?' + query : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_cAR_RENT_LISTING,
        payload: res.data.response?.data,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => {
      // console.log(err);
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const getcarRentCarListing = (data) => (dispatch) => {
  dispatch(showLoader());

  var BusinessID = sessionStorage.getItem('BusinessId');
  axios
    .get(API + `/carRent/car?businessId=${BusinessID}`, getConfig())
    .then((res) => {
      dispatch({
        type: GET_cAR_RENT_CAR_LISTING,
        payload: res.data.response?.data,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    })
    .catch((err) => {
      // console.log(err);
    })
    .finally(() => {
      dispatch(hideLoader());
    });
};

export const getWhatIsMyBusiness = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/business/my', getConfig()).then((res) => {
    console.log('getWhatIsMyBusiness response:', res.data);
    dispatch({
      type: GET_MY_BUSINESS,
      payload: res.data?.response,
    });
  }).catch(err => console.error('getWhatIsMyBusiness error:', err));
};

export const getAllParts = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios

    // .get(API + `/spareParts/part?sparePartsOwnerPartId=${data}`, getConfig())
    .get(API + '/admin/part/listing', getConfig())
    .then((res) => {
      dispatch({
        type: GET_SPARE_PARTS,
        payload: res?.data?.response,
      });
      // console.log(res);
      // dispatch(setLoading(false));
    });
  // .catch(err => console.log(err));
};

// Promote an existing banner to the business's MAIN_BANNER (backend demotes the
// old main). onDone() is called to refetch the banners on success.
export const setMainBanner = (businessMediaId, onDone) => (dispatch) => {
  axios
    .put(API + '/media/set-main-banner', { businessMediaId }, getConfig())
    .then(() => {
      if (typeof onDone === 'function') onDone();
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          'Could not set the main banner. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
      });
    });
};

export const deleteMediaBanner = (businessMediaId) => (dispatch) => {
  var object = { businessMediaId };
  // console.log('this is fatch ondata ', object);
  let query = '';
  Object.keys(object).forEach((key) => {
    // console.log('this is object key', key);
    query += key + '=' + object[key] + '&';
  });
  query = query.slice(0, -1);

  Swal.fire({
    title: i18n.t('Are you sure?'),
    text: i18n.t('You will not be able to recover this !'),
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: i18n.t('Yes, delete it!'),
    confirmButtonColor: '#e0e000',
    cancelButtonText: i18n.t('No, keep it'),
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios.delete(API + '/media' + '?' + query, getConfig()).then((res) => {
        Swal.fire({
          title: i18n.t('Deleted!'),
          text: i18n.t('You will not be able to recover this !'),
          imageUrl: './assets/images/test.png',
          imageHeight: 100,
          type: 'warning',
        });
        window.location.reload();
        // dispatch(getCategory());
      });
      // .catch(err => console.log(err));
    }
  });
};

// [FB2-#4] Batch-delete several banner media with ONE confirmation, deleting
// them all in parallel, then refresh once via the onDone callback. The old
// per-item deleteMediaBanner fired a fresh Swal + window.location.reload for
// EACH id in the same tick — the stacked Swals cancelled each other and the
// reload aborted the rest, so only the first selected photo was ever deleted.
export const deleteMediaBannerBatch = (businessMediaIds, onDone) => () => {
  const ids = (Array.isArray(businessMediaIds)
    ? businessMediaIds
    : [businessMediaIds]
  ).filter(Boolean);
  if (!ids.length) return;

  Swal.fire({
    title: i18n.t('Are you sure?'),
    text: `You will not be able to recover ${
      ids.length > 1 ? 'these items' : 'this'
    } !`,
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: i18n.t('Yes, delete it!'),
    confirmButtonColor: '#e0e000',
    cancelButtonText: i18n.t('No, keep it'),
  }).then((isConfirm) => {
    if (!isConfirm.value) return;
    Promise.all(
      ids.map((id) =>
        axios.delete(API + '/media?businessMediaId=' + id, getConfig())
      )
    )
      .then(() => {
        Swal.fire({
          title: i18n.t('Deleted!'),
          text: i18n.t('You will not be able to recover this !'),
          imageUrl: './assets/images/test.png',
          imageHeight: 100,
          type: 'warning',
        });
        if (typeof onDone === 'function') onDone();
      })
      .catch((err) => {
        Swal.fire({
          title:
            err?.response?.data?.response?.message ||
            'Could not delete. Please try again.',
          icon: 'error',
          confirmButtonColor: '#3ab1f7',
        });
      });
  });
};

//get plans

export const getPlansListing = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios', data);

  axios
    .get(
      API + `/payment/plans`,

      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_ALL_PLANS,
        payload: res.data?.response?.data,
      });

      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error(err);
      dispatch(setLoading(false));
    });
};

// make payment

export const makePayment = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios', data);

  axios
    .post(
      API + `/payment/new`,
      data,

      getConfig()
    )
    .then((res) => {
      dispatch({
        type: MAKE_NEW_PAYMENT,
        payload: res.data,
      });
      console.log('resDataPayment', res.data, data);
      Swal.fire({
        title: i18n.t('Subscribed successfully'),
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('Ok'),
      });
      // Refresh the business so the sidebar unlocks and the plan reflects
      // immediately (free purchase otherwise required a manual refresh).
      dispatch(getWhatIsMyBusiness());
    })
    .catch((err) => {
      Swal.fire({
        title: err.response.data?.message.toUpperCase(),
        imageUrl: './assets/images/error.png',
        imageHeight: 100,
        type: 'warning',
      });
      // 	dispatch({
      // 	type: MAKE_NEW_PAYMENT,
      // 	payload: err.response.data
      // })
    });
};

export const getAllSubscriptions = (data) => (dispatch) => {
  // var data = new URLSearchParams();
  // console.log('this is inside axios', data);

  axios
    .post(
      API + `/payment/get-all-user-subscriptions`,
      data,
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_ALL_PACKAGES_HISTORY,
        payload: res.data,
      });
      console.log('resDataPaymentSubscripotions', res.data, data);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.error(err);
      dispatch(setLoading(false));
    });
};

// SETTINGS -> GETTING SAVED DATA

export const getSavedItems = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/savedItem/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_SAVED_ITEMS_LIST,
      payload: res?.data?.response?.data || [],
    });
    dispatch(setLoading(false));
  }).catch((err) => {
    console.error('Error fetching saved items:', err);
    dispatch({
      type: GET_SAVED_ITEMS_LIST,
      payload: [],
    });
    dispatch(setLoading(false));
  });
};

export const saveAItem = (data) => (dispatch) => {
  // Check if user is logged in before attempting to save
  if (!sessionStorage.getItem('loged_In_auth')) {
    Swal.fire({
      title: i18n.t('Please log in to save items'),
      icon: 'warning',
      confirmButtonColor: '#3ab1f7',
      confirmButtonText: i18n.t('Login'),
      showCancelButton: true,
      cancelButtonText: i18n.t('Cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = '#/login';
      }
    });
    return;
  }

  // No blocking loader / no blocking success popup — the heart turns yellow
  // instantly in the UI (optimistic). We only show a brief, non-blocking toast.
  axios
    .post(API + '/savedItem/listing', data, getConfig())
    .then(() => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: i18n.t('Saved'),
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });
    })
    .catch((err) => {
      const errorMessage = err?.response?.data?.response?.message;
      // Duplicate save is fine — the item is already saved, nothing to alert about.
      if (
        err?.response?.status === 409 ||
        (errorMessage && errorMessage.toLowerCase().includes('already'))
      ) {
        return;
      }
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: errorMessage || 'Could not save item',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    });
};

export const removeSavedItem = (data) => (dispatch) => {
  // No page reload — the heart toggles back to grey instantly in the UI
  // (optimistic). We refresh the saved-items list in the background so the
  // Saved Items page and any saved-set stays in sync, plus a brief toast.
  axios
    .delete(API + `/savedItem/listing?savedItemId=${data?.savedItemId}`, getConfig())
    .then(() => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: i18n.t('Removed'),
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });
      // Keep the saved list fresh without reloading the page.
      dispatch(getSavedItems());
    })
    .catch((err) => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title:
          err?.response?.data?.response?.message || 'Something went wrong',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    });
};

// GET RECENT VIEWED CARS

export const getRecentViewedCars = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/recentlyViewedCars/listing', getConfig()).then((res) => {
    dispatch({
      type: GET_RECENT_VIEWED_CARS_LIST,
      payload: res?.data?.response?.data || [],
    });
  }).catch((err) => {
    console.error('Error fetching recently viewed cars:', err);
    dispatch({
      type: GET_RECENT_VIEWED_CARS_LIST,
      payload: [],
    });
    dispatch(setLoading(false));
  });
};

export const addToRecentlyViewed = (data) => (dispatch) => {
  // Only track if user is logged in
  if (!sessionStorage.getItem('loged_In_auth')) return;

  axios.post(API + '/recentlyViewedCars/listing', data, getConfig())
    .then((res) => {
      // Silently track - no need to notify user
    })
    .catch((err) => {
      console.error('Error adding to recently viewed:', err);
    });
};

// When the phone number changed, verify the NEW number via OTP first, then save
// the profile. (No phone change -> save directly.) Uses the existing OTP
// endpoints; the master OTP still works while SMS is down.
export const updateProfileWithOtpIfPhoneChanged =
  (data, ctx) => (dispatch) => {
    if (!ctx || !ctx.phoneChanged) {
      dispatch(updateUserProfile(data));
      return;
    }
    const otpCtx = {
      userId: ctx.userId,
      countryCode: ctx.countryCode,
      mobileNumber: ctx.mobileNumber,
    };
    dispatch(setLoading(true));
    axios
      .post(API + '/otp/resend', otpCtx, getConfig())
      .then(() => {
        dispatch(setLoading(false));
        // [FB2-#8b] The Edit Profile Bootstrap modal (#edit-modal) is still open
        // and its focus-trap (enforceFocus) yanks focus back whenever the user
        // clicks the SweetAlert OTP input — so the field "cannot be typed in".
        // Hide the Bootstrap modal before opening the OTP prompt so its input
        // can hold focus.
        const editEl = document.getElementById('edit-modal');
        if (editEl) {
          try {
            // eslint-disable-next-line global-require
            const { Modal } = require('bootstrap');
            (Modal.getInstance(editEl) || Modal.getOrCreateInstance(editEl)).hide();
          } catch (e) {}
          try {
            if (window.$ && window.$(editEl).modal) window.$(editEl).modal('hide');
          } catch (e) {}
          editEl.classList.remove('show');
          editEl.style.display = 'none';
          document.body.classList.remove('modal-open');
          document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
        }
        Swal.fire({
          title: i18n.t('Verify your new number'),
          input: 'text',
          inputLabel: 'Enter the OTP sent to ' + ctx.mobileNumber,
          inputAttributes: { inputmode: 'numeric', maxlength: 6 },
          showCancelButton: true,
          confirmButtonText: i18n.t('Verify'),
          confirmButtonColor: '#3ab1f7',
          allowOutsideClick: false,
          didOpen: () => {
            const inp = Swal.getInput();
            if (inp) inp.focus();
          },
        }).then((r) => {
          if (!r.isConfirmed || !r.value) return;
          dispatch(setLoading(true));
          axios
            .post(
              API + '/otp/verify',
              { ...otpCtx, otp: String(r.value).trim() },
              getConfig()
            )
            .then(() => {
              dispatch(setLoading(false));
              dispatch(updateUserProfile(data));
            })
            .catch(() => {
              dispatch(setLoading(false));
              Swal.fire({
                title: i18n.t('Invalid or expired OTP'),
                icon: 'error',
                confirmButtonColor: '#3ab1f7',
              });
            });
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        Swal.fire({
          title:
            err?.response?.data?.response?.message ||
            'Could not send OTP. Please try again.',
          icon: 'error',
          confirmButtonColor: '#3ab1f7',
        });
      });
  };

// [FB2-PENDING] Phone-change OTP — registration-style flow, but driven by the
// SettingsEditProfile component so the OTP modal can STAY OPEN on a wrong code
// (the old Swal-input closed on first wrong entry, losing the session).
// These thunks just return the axios promise; the component owns the UI, the
// resend cooldown and the auto-fill. TESTING: SMS is down, so /otp/resend
// echoes the freshly-generated code back (res.data.response.otp) — auto-filled
// like the registration screen. REMOVE the auto-fill once SMS is restored.
export const sendPhoneChangeOtp = (otpCtx) => () =>
  axios.post(API + '/otp/resend', otpCtx, getConfig());

export const verifyPhoneChangeOtp = (payload) => () =>
  axios.post(API + '/otp/verify', payload, getConfig());

export const updateUserProfile = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.patch(API + '/user/profile', data, getConfig()).then((res) => {
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: res?.data?.response,
    });
    // Close the Edit Profile modal on success (it previously stayed open /
    // appeared to "redirect back" to Edit Profile).
    const el = document.getElementById('edit-modal');
    if (el) {
      try {
        const { Modal } = require('bootstrap');
        (Modal.getInstance(el) || Modal.getOrCreateInstance(el)).hide();
      } catch (e) {}
      try {
        if (window.$ && window.$(el).modal) window.$(el).modal('hide');
      } catch (e) {}
      el.classList.remove('show');
      el.style.display = 'none';
      document.body.classList.remove('modal-open');
      document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
    }
    Swal.fire({
      title: i18n.t('Profile Updated Successfully'),
      icon: 'success',
      confirmButtonColor: '#3ab1f7',
      confirmButtonText: i18n.t('Ok'),
    }).then(() => {
      // Refresh profile data after update
      dispatch(gettingUserProfile());
    });
    dispatch(setLoading(false));
  }).catch((err) => {
    console.error('Error updating profile:', err);
    Swal.fire({
      title: err?.response?.data?.response?.message || 'Error updating profile',
      icon: 'error',
      confirmButtonColor: '#3ab1f7',
      confirmButtonText: i18n.t('Ok'),
    });
    dispatch(setLoading(false));
  });
};

export const gettingUserProfile = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + '/user/profile', getConfig()).then((res) => {
    // The API may return user data directly under response or nested under response.data
    const profileData = res?.data?.response?.data || res?.data?.response;
    dispatch({
      type: GETTING_USER_PROFILE,
      payload: profileData,
    });
  }).catch((err) => {
    console.error('Error fetching user profile:', err);
    dispatch(setLoading(false));
  });
};

export const gettingUserCarDetails = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + `/carSale/listing?carSaleId=${data}`, getConfig()).then((res) => {
    dispatch({
      type: GETTING_USER_CAR_DETAILS,
      payload: res?.data?.response,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err))
};

export const getMyPost = () => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + `/carSale/listing?my=1`, getConfig()).then((res) => {
    console.log('res', res);
    dispatch({
      type: GETTING_USER_MY_POST,
      payload: res?.data?.response?.data,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err))
};

export const deleteMyPost = (carSaleId) => (dispatch) => {
  axios
    .delete(API + `/carSale/listing?carSaleId=${carSaleId}`, getConfig())
    .then(() => {
      Swal.fire({
        title: i18n.t('Deleted Successfully'),
        icon: 'success',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
      dispatch(getMyPost());
    })
    .catch((err) => {
      Swal.fire({
        title:
          err?.response?.data?.response?.message ||
          'Could not delete the post. Please try again.',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: i18n.t('Ok'),
      });
    });
};

export const getUserGarageFilterA2Z = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + `/garageOwner/listing?sort=a2z`, getConfig()).then((res) => {
    dispatch({
      type: USER_GARAGE_AZ_FILTER,
      payload: res?.data?.response,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err))
};

export const getUserGarageFilterZ2A = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + `/garageOwner/listing?sort=z2a`, getConfig()).then((res) => {
    dispatch({
      type: USER_GARAGE_ZA_FILTER,
      payload: res?.data?.response,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err))
};

export const filterGarageListCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(API + `/garageOwner/listing?category=${data}`, getConfig())
    .then((res) => {
      dispatch({
        type: FILTER_GARAGE_LIST_WITH_CATEGORY,
        payload: res?.data?.response,
      });
      // console.log(res);
    });
  // .catch(err => console.log(err))
};

export const getSparePartsA2Z = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + `/spareParts/listing?sort=a2z`, getConfig()).then((res) => {
    dispatch({
      type: USER_SPARE_PARTS_AZ_FILTER,
      payload: res?.data?.response,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err))
};

export const getSparePartsZ2A = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios.get(API + `/spareParts/listing?sort=z2a`, getConfig()).then((res) => {
    dispatch({
      type: USER_SPARE_PARTS_ZA_FILTER,
      payload: res?.data?.response,
    });
    // console.log(res);
  });
  // .catch(err => console.log(err))
};
export const filteredCategoryList = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(API + `/spareParts/listing?category=${data}`, getConfig())
    .then((res) => {
      dispatch({
        type: FILTER_SPARE_PARTS_WITH_CATEGORY,
        payload: res?.data?.response,
      });
      // console.log(res);
    });
  // .catch(err => console.log(err))
};

// PERSIST BANNER REORDER (fire-and-forget)
export const reorderBannerMedia = (ids) => () => {
  axios
    .put(API + '/media/reorder', { ids }, getConfig())
    .then((res) => {
      // console.log(res);
    })
    .catch((err) => {
      console.error('reorderBannerMedia error:', err);
    });
};

// PERSIST CAR-DEALER CAR ORDER (fire-and-forget). `ids` is the full carId list
// in the new display order; the backend stamps each car's `priority` to match.
export const reorderCarDealerCars = (ids) => () => {
  axios
    .put(API + '/carDealer/reorder', { ids }, getConfig())
    .then((res) => {
      // console.log(res);
    })
    .catch((err) => {
      console.error('reorderCarDealerCars error:', err);
    });
};

// PERSIST RENT-CAR CAR ORDER (fire-and-forget). Same contract as the dealer
// reorder, against the carRent module / rentalCars table.
export const reorderCarRentCars = (ids) => () => {
  axios
    .put(API + '/carRent/reorder', { ids }, getConfig())
    .then((res) => {
      // console.log(res);
    })
    .catch((err) => {
      console.error('reorderCarRentCars error:', err);
    });
};

// PERSIST CAR-AGENT CAR ORDER (fire-and-forget). Same contract, against the
// carAgent module / agent_cars table (ids are carId = carAgencyId).
export const reorderCarAgentCars = (ids) => () => {
  axios
    .put(API + '/carAgent/reorder', { ids }, getConfig())
    .then((res) => {
      // console.log(res);
    })
    .catch((err) => {
      console.error('reorderCarAgentCars error:', err);
    });
};

// PERSIST MY-POSTS (car-for-sale) ORDER (fire-and-forget). `ids` is the
// carSaleId list in the new order; scoped to the logged-in user on the backend.
export const reorderMyPosts = (ids) => () => {
  axios
    .put(API + '/carSale/reorder', { ids }, getConfig())
    .then((res) => {
      // console.log(res);
    })
    .catch((err) => {
      console.error('reorderMyPosts error:', err);
    });
};

// GET CAR MODELS BY BRAND
export const getCarModels = (brandId) => (dispatch) => {
  axios
    .get(
      // The route is GET /admin/brand/carModel/LISTING — without the /listing
      // segment this 404'd every time, so `carModels` stayed empty and every
      // car form fell back to the manual free-text box instead of the dropdown.
      API +
        '/admin/brand/carModel/listing' +
        (brandId ? '?brandId=' + brandId : ''),
      getConfig()
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_MODELS,
        payload: res?.data?.response,
      });
      // console.log(res);
    })
    .catch((err) => {
      console.error('getCarModels error:', err);
    });
};
